import React from 'react'
import img from '../../images/Uso Personal y Doméstico_1-74.4b7e77c94690d348175b 1.png'
import { useLanguage } from "../../Providers/LanguageContext";
import GooglePlay from "../../images/google-play.png";
import AppStore from "../../images/app-store.png";
const TakeControl = () => {
  const { language, currentLanguage } = useLanguage();
  return (
    <>
      <div className="take_control_wrapper">
        <div className="take-control-bg">
          <div className="container-fluid take_control_main">
            <div className='take_control_right'>
              <h1>{language.homeControlHead.toUpperCase()}</h1>
              <h6>{language.homeControlPara}</h6>


              <div className="app_store_wrapper">
                <div className="google_img">
                  <a href='https://play.google.com/store/apps/details?id=com.fisibilitylite' target={"_blank"}>
                    <img src={GooglePlay} className="img-fluid" alt="image" />
                  </a>
                </div>
                <div className="app_store">
                  <a href="https://apps.Apple.com/mx/app/Fisibility-Lite/id1633678357" target={"_blank"}>
                    <img style={{
                      width: '158px'
                    }} src={AppStore} className="img-fluid" alt="image" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TakeControl
